/* @flow */
import React from 'react';
import styled from 'styled-components';
import { Row } from 'react-grid-system';
import {
    Button,
    PromptText,
    Modal,
    ModalTitle,
    LoadingIndicator,
} from 'listertech-commons-web';
import { callDeleteOne } from '../../api/users';

const ModalButtons = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    min-width: 400px;
    margin-top: 40px;

    > * {
        width: auto;
        padding: 0px 20px;
    }
`;

const Title = styled(ModalTitle)`
    display: inline-block;
`;

const TitleExtra = styled.p`
    display: inline-block;
    margin-left: 10px;
    color: red;
`;

const DeleteModal = props => {
    const { contractors, onClose } = props;

    const deleteUsers = async () => {
        try {
            if(Array.isArray(contractors)) {
                await Promise.all(contractors.map(c => callDeleteOne(c._id)));
            } else {
                await callDeleteOne(contractors._id);
            }
            onClose();
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <Modal visible>
            <ModalTitle>
                Delete Contractor
            </ModalTitle>
            <PromptText>
                Are you sure you want to delete these contractors?
            </PromptText>
            <ModalButtons>
                <Button
                    theme="dark"
                    onClick={onClose}
                    noMargin
                    style={{ minWidth: '200px' }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={deleteUsers}
                    noMargin
                    style={{ minWidth: '200px' }}
                >
                    Delete Contractor
                </Button>
            </ModalButtons>
        </Modal>
    );
};

export default DeleteModal;